export const SITE_INFO_B2B = {
  id: 2,
  slugEn: 'infobumpertobumper',
  slugFr: 'infobumpertobumper',
  protected: true
}

export const SITE_ACADEMY = {
  id: 10,
  slugEn: 'academy',
  slugFr: 'academie',
  protected: false
}

export const SITE_AUTOPARTS = {
  id: 4,
  slugEn: 'operationmanual',
  slugFr: 'manuelautoparts',
  protected: true
}

const SITE_AUTOSERVICE = {
  id: 5,
  slugEn: 'autoservicemanual',
  slugFr: 'manuelautoservice',
  protected: true
}

export const SITE_LANDING = {
  id: 11,
  slugEn: 'btbas-fall-2022',
  slugFr: 'btbas-automne-2022',
  protected: false
}

export const SITE_LANDING2 = {
  id: 12,
  slugEn: 'btbas-winter-2023',
  slugFr: 'btbas-hiver-2023',
  protected: false
}

const ALL_SUPPORTED_SITES = [
  SITE_INFO_B2B,
  SITE_ACADEMY,
  SITE_AUTOPARTS,
  SITE_AUTOSERVICE,
  SITE_LANDING,
  SITE_LANDING2
]

export const DOMAINS = {
  development: 'localhost:8080',
  staging: 'staging.bumpertobumper.ca',
  production: 'bumpertobumper.ca'
}

const DomainToSiteMap = (() => {
  const domainMap = new Map()

  // eslint-disable-next-line
  for (const lang of ['en', 'fr']) {
    // eslint-disable-next-line
    for (const site of ALL_SUPPORTED_SITES) {
      const key = `slug${lang[0].toUpperCase()}${lang[1]}`
      domainMap.set(`${site[key]}`, site.id)
    }
  }
  return domainMap
})()

/**
 * Build a map of localized slugs to site ids supported
 * by this codebase.
 * {Map<string,number>}
 * @return
 */
const SlugToSiteMap = (() => {
  const slugMap = new Map()

  // eslint-disable-next-line
  for (const lang of ['en', 'fr']) {
    // eslint-disable-next-line
    for (const site of ALL_SUPPORTED_SITES) {
      const key = `slug${lang[0].toUpperCase()}${lang[1]}`
      slugMap.set(`/${lang}/${site[key]}`, site.id)
    }
  }
  return slugMap
})()

/**
 * Get site ID based on current URL
 * @return {number}
 */
export const getSiteIdByDomain = (currentUrl) => {
  let matchedSiteId = 1
  const subdomain = currentUrl.split('.')[0]
  /* eslint-disable-next-line */
  for (const slugMap of DomainToSiteMap.entries()) {
    const [slug, siteId] = slugMap
    if (slug === subdomain) {
      matchedSiteId = siteId
      break
    }
  }
  return matchedSiteId
}

/**
 * Check if site is protected or not
 * @return {number}
 */
export const getSiteProtectionStatus = (siteID) => {
  let isProtected = false
  // eslint-disable-next-line no-restricted-syntax
  for (const site of ALL_SUPPORTED_SITES) {
    if (site.id === siteID) {
      isProtected = site.protected
      break
    }
  }
  return isProtected
}

export const getDomainByEnv = () => {
  const env = process.env.NODE_ENV
  return DOMAINS[env]
}

/**
 * Check if site is protected or not
 * @return {string}
 */
export const getDomainBySiteId = (siteID, lang) => {
  let subdomain = ''
  // eslint-disable-next-line no-restricted-syntax
  for (const site of ALL_SUPPORTED_SITES) {
    if (site.id === siteID) {
      if (lang === 'fr-CA') {
        subdomain = site.slugFr
      } else {
        subdomain = site.slugEn
      }
      break
    }
  }
  if (subdomain === '') return subdomain

  return `${subdomain}.${getDomainByEnv()}`
}

/**
 * Get site ID based on current URL
 * @param currentUrl
 * @return {number}
 */
export const getSiteIdForURL = (currentUrl) => {
  let matchedSiteId = 1

  /* eslint-disable-next-line */
  for (const slugMap of SlugToSiteMap.entries()) {
    const [slug, siteId] = slugMap
    const regexp = new RegExp(`^${slug}.*$`)
    const match = regexp.test(currentUrl)

    if (match) {
      matchedSiteId = siteId
      break
    }
  }
  return matchedSiteId
}

export const ALGOLIA = {
  appId: '8UIV5LO1IM',
  apiKey: '1fc7e8c2dce4a08b4dc2a519af3cc900'
}

export default SITE_AUTOSERVICE
